<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Hosting</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item color="secondary">
        Location of the campaign hosting servers.
    </ion-item>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item>
                <ion-label class="ion-text-wrap">
                    <span class="line1">Enabled</span><br />
                    <span class="line2">{{vm.enabledStr}}</span>
                </ion-label>
                <ion-toggle data-test="enabled" id="enabled" [(ngModel)]="vm.enabled" 
                        name="toggle" (ionChange)="onEnabledChange()">
                </ion-toggle>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Campaign Link</ion-label>
                <ion-input data-test="campaignHostingLink" color="secondary" type="text" name="campaignHostingLink" #campaignHostingLink="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && campaignHostingLink.invalid }" required
                    [(ngModel)]="vm.campaignHostingLink" id="rawMessage" autofocus="true"
                    [disabled]="vm.enabled">
                </ion-input>
                @if (submitted && campaignHostingLink.invalid) {
  <div>
                    <div class="validationErrorMsg">Enter the url of your campaign page.</div>
                </div>
}
            </ion-item>

            <!-- <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Cell Phone: Receive text, Shuttle is Ready.</ion-label>
                <ion-input id="cellPhone" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx"
                    [(ngModel)]="vm.ticket.cellPhone" name="phone" [class.invalid]="isInvalid1('cellPhone')">
                </ion-input>
            </ion-item>
            @if (isInvalid2('cellPhone', vm.ticket.cellPhone, 'optphone')) {
  <ion-item> 
                    <p class="validationErrorMsg">Please enter a valid cell phone number.</p>
            </ion-item>
} -->

            <!-- 
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Campaign Opt Out Link</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="vm.campaignOptoutLink" #optoutLink id="optoutLink"
                    placeholder="The optout link.">
                </ion-input>
            </ion-item> -->
            <!-- </div> -->
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="save" color="primary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>